import React from 'react'
import PropTypes from 'prop-types'

import {
  ContextualHelpBox,
  ContextMessage,
  Content,
  IconCol,
  ContentCol,
  ContentMessage,
  Footer,
} from './ContextualHelp.style'

const ContextualHelp = ({ contextMsg, contentMsg, icon, children }) => (
  <ContextualHelpBox>
    {contextMsg && <ContextMessage>{contextMsg}</ContextMessage>}
    <Content>
      <IconCol>{icon}</IconCol>
      <ContentCol>
        <ContentMessage>{contentMsg}</ContentMessage>
        <Footer>{children}</Footer>
      </ContentCol>
    </Content>
  </ContextualHelpBox>
)

ContextualHelp.propTypes = {
  contextMsg: PropTypes.node,
  contentMsg: PropTypes.node,
  icon: PropTypes.node,
  children: PropTypes.node,
}

export default ContextualHelp
